import { User } from "../../types"


type Props = React.PropsWithChildren<{
    users: User[]
}>

export function HeaderRow({ users, children }: Props) {

    return <>

        <div className="header row-header" style={{ gridColumn: 1 }}>
            {children}
        </div>

        {
            users.map((c, index) => <div key={c.userId} className="header user" style={{ gridColumn: (index + 2) }}>

                {
                    c.firstName && c.lastName
                        ? <span title={c.email}>
                            {c.firstName}
                            <br />{c.lastName}
                        </span>
                        : <span title={c.email}>
                            {c.lastName || c.firstName}
                        </span>
                }

            </div>)
        }

    </>
}